import { ClerkOptions } from "@clerk/types";

export const allowedRedirectOrigins = [
  // marketplace
  "https://www.local.vendr-dev.com/",
  "https://www.preview.vendr-dev.com/",
  "https://www.staging.vendr.com/",
  "https://www.vendr.com/",

  // ai
  "https://ai.local.vendr-dev.com/",
  "https://ai.preview.vendr-dev.com/",
  "https://ai.staging.vendr.com/",
  "https://ai.vendr.com/",

  // agent
  "https://agent.local.vendr-dev.com/",
  "https://agent.preview.vendr-dev.com/",
  "https://agent.staging.vendr.com/",
  "https://agent.vendr.com/",
];

export const clerkOptions: ClerkOptions = {
  allowedRedirectOrigins,
  appearance: {
    variables: {
      colorPrimary: "#4506ff",
    },
    layout: {
      socialButtonsPlacement: "bottom",
    },
  },
  localization: {
    signUp: {
      start: {
        title: "Create your free account",
      },
    },
    signIn: {
      start: {
        title: "Sign in to Vendr",
      },
    },
  },
};
